import { Box, Chip, styled } from '@mui/material';

export const PillStyled = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'variant',
})(({ theme, variant }) => ({
  borderRadius: '3px',
  border: `solid 1px ${theme.palette.colors.pillBorder}`,
  backgroundColor: theme.palette.colors.secondaryBackground,
  color: theme.palette.colors.mainFocused,
  textTransform: 'uppercase',
  fontWeight: 500,
  height: 'fit-content',
  fontSize: '12px',
  lineHeight: 'normal',
  '& span': {
    padding: '2px 6px',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '10px',
    height: '16px',
  },
  ...(variant === 'orderQuantity' && {
    backgroundColor: theme.palette.colors.pillBackgroundGloomy,
    color: theme.palette.colors.secondaryBackground,
    width: 92,
    minWidth: 92,
    [theme.breakpoints.down('md')]: {
      width: 74,
      fontSize: '10px',
      height: '16px',
    },
  }),
  ...(variant === 'orderAmount' && {
    backgroundColor: theme.palette.colors.pillBackgroundLight,
    color: theme.palette.colors.pillBorder,
    width: 92,
    minWidth: 92,
    [theme.breakpoints.down('md')]: {
      width: 74,
      fontSize: '10px',
      height: '16px',
    },
  }),
  ...(variant === 'stateCancel' && {
    backgroundColor: theme.palette.colors.down,
    borderRadius: '8px',
    width: '40px',
    height: '14px',
    border: `solid 1px ${theme.palette.colors.pillBorder}`,
    backgroundImage: `linear-gradient(110deg, ${theme.palette.colors.down} 30%, ${theme.palette.colors.secondaryBackground} 30%, ${theme.palette.colors.secondaryBackground}  50%, ${theme.palette.colors.down} 50%, ${theme.palette.colors.down} 80%, ${theme.palette.colors.secondaryBackground}  80%, ${theme.palette.colors.secondaryBackground}  100%);`,
    backgroundSize: '7.45px 20.47px',
    '& span': {
      marginLeft: '48px',
    },
    [theme.breakpoints.down('lg')]: {
      width: '56px',
      height: '12px',
    },
  }),
  ...(variant === 'statePending' && {
    backgroundColor: theme.palette.colors.secondaryBackground,
    borderRadius: '8px',
    width: '40px',
    height: '14px',
    border: `solid 1px ${theme.palette.colors.pillBorder}`,
    '& span': {
      marginLeft: '48px',
    },
    [theme.breakpoints.down('lg')]: {
      width: '56px',
      height: '12px',
    },
  }),
  ...((variant === 'open' || variant === 'readAll' || variant === 'delete') && {
    backgroundColor:
      variant === 'open'
        ? theme.palette.colors.primaryBackground
        : theme.palette.colors.secondaryBackground,
    borderRadius: variant === 'open' ? '10px' : '12px',
    width: variant === 'open' ? '62px' : variant === 'delete' ? '48px' : '67px',
    height: variant === 'open' ? '20px' : '24px',
    border: `solid 1px ${theme.palette.colors.pillBorder}`,
    textTransform: 'capitalize',
    fontWeight: 700,
    '& span': {
      paddingLeft: variant === 'open' ? 8 : 0,
      paddingRight: variant === 'open' ? 4 : 0,
      fontSize: '12px',
      lineHeight: 'normal',
      [theme.breakpoints.down('md')]: {
        fontSize: variant === 'open' ? '10px' : '12px',
      },
    },
    [theme.breakpoints.down('md')]: {
      width:
        variant === 'open' ? '52px' : variant === 'delete' ? '48px' : '67px',
      fontSize: variant === 'open' ? '10px' : '12px',
      height: variant === 'open' ? '16px' : '24px',
    },
  }),
  ...(variant === 'addItem' && {
    backgroundColor: theme.palette.colors.secondaryBackground,
    borderRadius: '12px',
    width: 'fit-content',
    border: `solid 1px ${theme.palette.colors.pillBorder}`,
    textTransform: 'capitalize',
    fontSize: '12px',
    fontWeight: 700,

    '& span': {
      padding: '5px 16px',
      fontSize: '12px',
      lineHeight: 'normal',
    },

    [theme.breakpoints.down('md')]: {
      '& span': {
        padding: '5px 16px',
      },
    },
  }),
}));

export const TrlPillContainer = styled(Box)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '12px',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  display: 'flex',
  alignItems: 'center',
}));

export const TrlPillLabel = styled('span')(({ theme }) => ({
  fontWeight: 500,
  fontSize: '12px',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  marginLeft: theme.spacing(),
  [theme.breakpoints.down('lg')]: {
    textTransform: 'uppercase',
  },
}));
